/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import NewEmail from "./newEmail";
import VerifyEmail from "./verifyEmail";
import DynamicImageLoader from '../../dynamicImageLoader';
import { ReactComponent as EditEmailSvg } from '../../../resources/images/edit.svg';


/* Styles */
import styles from "./styles";


const UpdateEmailModal = ({showUpdateEmailModal, setShowUpdateEmailModal, travelerDetails }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const [emailStep, setEmailStep] = useState("0");
  const [enteredEmail, setEnteredEmail] = useState("");

  useEffect(() => {
    if (!showUpdateEmailModal) {
      setEmailStep("0")
      setEnteredEmail("")
    }
  }, [showUpdateEmailModal]);


  return (
    <UCModal
      className={emailStep === "0" ? classes.updateEmailModal : `${classes.updateEmailModal} ${classes.verifyEmailHeader}`}
      showModal={ showUpdateEmailModal }
      setShowModal={ setShowUpdateEmailModal }
      modalIcon={emailStep === "0" ?  <EditEmailSvg /> : <DynamicImageLoader imageName={"edit-email.svg"} /> }
      modalTitle={ emailStep === "0" ?
        <FormattedMessage id="updateEmailModal.newEmailTitle"/> :
        <p className={classes.verifyEmailDesc}>
          <FormattedMessage id="updateEmailModal.verifyEmailTitle"/>
        </p>
       }
      modalDescription={ emailStep === "0" ?
        <FormattedMessage id="updateEmailModal.newEmailDescription" values={{firstName: travelerDetails.firstName, lastName: travelerDetails.lastName}}/> :
        <p className={classes.verifyEmailDesc}>
          <FormattedMessage id="updateEmailModal.verifyEmailDescription" values={{email: enteredEmail}} />
        </p>
       }
      modalContent={
      <>
        {emailStep === "0" && (
          <NewEmail
            setShowModal={setShowUpdateEmailModal}
            emailStep={emailStep}
            setEmailStep={setEmailStep}
            travelerDetails={travelerDetails}
            setEnteredEmail={setEnteredEmail}
          />
        )}
        {emailStep === "1" && (
          <VerifyEmail
            setShowModal={setShowUpdateEmailModal}
            emailStep={emailStep}
            setEmailStep={setEmailStep}
            travelerDetails={travelerDetails}
            enteredEmail={enteredEmail}
          />
        )}
      </>
     }
    />
  )
}

export default UpdateEmailModal;
